export const DuracaoConsultaModel = [
    { name: '5 minutos', value: 5 },
    { name: '10 minutos', value: 10 },
    { name: '15 minutos', value: 15 },
    { name: '20 minutos', value: 20 },
    { name: '30 minutos', value: 30 },
    { name: '35 minutos', value: 35 },
    { name: '40 minutos', value: 40 },
    { name: '45 minutos', value: 45 },
    { name: '50 minutos', value: 50 },
    { name: '55 minutos', value: 55 },
    { name: '60 minutos', value: 60 },
]
